import { useCallback, useEffect, useRef } from 'react';
import {
  createSearchParams,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';

import Wizard from './Wizard';

const QUERY_STEP_FIELD = 'step';

export default function RouterWizard({ children, ...props }) {
  const wizardRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const urlActiveNamedStep = searchParams.get(QUERY_STEP_FIELD);

  useEffect(() => {
    if (wizardRef && wizardRef.current) {
      if (
        urlActiveNamedStep &&
        wizardRef.current.currentNamedStep !== urlActiveNamedStep
      ) {
        wizardRef.current.goToNamedStep(urlActiveNamedStep);
      }
    }
  }, [urlActiveNamedStep]);

  useEffect(() => {
    if (!urlActiveNamedStep) {
      navigate(
        {
          pathname: location.pathname,
          search: createSearchParams({
            ...Object.fromEntries(searchParams),
            step: wizardRef.current?.currentNamedStep,
          }).toString(),
        },
        {
          state: location.state,
          replace: true,
        }
      );
    }
    return () => {};
  }, []);

  const handleSearchStepParam = useCallback(
    activeNamedStep => {
      navigate(
        {
          pathname: location.pathname,
          search: createSearchParams({
            ...Object.fromEntries(searchParams),
            step: activeNamedStep,
          }).toString(),
        },
        {
          state: location.state,
          replace: true,
        }
      );
    },
    [location.pathname, location.state, navigate, searchParams]
  );

  const handleStepChange = useCallback(
    payload => {
      if (urlActiveNamedStep !== payload.activeNamedStep) {
        handleSearchStepParam(payload.activeNamedStep);
      }
      props.onStepChange && props.onStepChange(payload);
    },
    [props.onStepChange, urlActiveNamedStep, handleSearchStepParam]
  );

  return (
    <Wizard
      {...props}
      initialNamedStep={urlActiveNamedStep}
      instance={ref => {
        wizardRef.current = ref;
        props.instance && props.instance(ref);
      }}
      onStepChange={handleStepChange}
    >
      {children}
    </Wizard>
  );
}

RouterWizard.propTypes = Wizard.propTypes;
